import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=ff5ff164&"
import script from "./ViewHeader.vue?vue&type=script&lang=ts&"
export * from "./ViewHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports